import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { seedUiLanguage } from "./app/core/i18n/detect-ui-language";

seedUiLanguage("tts_ui_language"); // same value as storageKey in app.config.ts

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
